import api from "../../api";

//YON 07-10-2025: This method seems very obsolete now. Should be removed.
export const getCorrectItemPrices = (items: PurchaseItem[]): PurchaseItem[] => {
    return items.map(i => {
        return {
            no: i.no,
            amount: i.amount,
            description: i.description,
            discountPercent: i.discountPercent,
            itemNo: i.itemNo,
            itemPrice: i.itemPrice,
            price: i.itemPrice,
            discountPrice: i.discountPrice,
            type: i.type,
            name: i.name,
            twoPersonJob: i.twoPersonJob || false,
            isMainItem: i.isMainItem || false
        } as PurchaseItem;
    });
};

export async function updateDebitorPrices(
    debitor: Partial<Debitor>,
    order: Order
) {
    if (
        order.items.length > 0 &&
        debitor.no
    ) {
        return await api.DebitorApi.getDebitorPrices(
            debitor.no,
            order.items.map<ProductPriceRequest>(p => ({
                productNo: p.itemNo,
                substituteNo: p.substituteNo,
                amount: p.amount,
                isMainItem: p.isMainItem || false
            })),
            order.additionalData.whoIsPaying,
            order.car.insurance,
            order.additionalData.orderType
        );
    }
    return order.items;
}
